import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Input,
} from "reactstrap";
import { DatePicker } from "reactstrap-date-picker";
import { MdOutlineDateRange } from "react-icons/md";
import SelectedUser from "../SelectedUser";
import ChoseMembers from "../ChoseMembers";

function ChangeOwner(props) {
  const formik = props?.formik;
  return (
    <Modal
      isOpen={props.changeOwnerModal}
      toggle={props.changeOwnerModaltoggle}
      size="md"
      centered
    >
      <ModalHeader toggle={props.changeOwnerModaltoggle}>
        Change Ownership
      </ModalHeader>
      <ModalBody>
        <Form className="formWrap">
          <ChoseMembers
            onSelect={(user) => props?.handleSelectUsers(user)}
          />

          <SelectedUser
            onRemove={(user) => props?.removeSelectUsers(user)}
            selectedUsers={props?.selectedUsers}
          />
          <div className="formElmWrap">
            <Input
              id="note"
              name="note"
              placeholder="Description"
              type="textarea"
              onChange={(e) => props?.setNote(e.target.value)}
              rows={7}
            />
          </div>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color={
            props?.selectedUsers.length > 0 ? "primary" : "disable"
          }
          onClick={() => {
            if (props?.selectedUsers.length > 0) props.handleSubmit();
          }}
        >
          Change Owner
        </Button>
        <Button
          color="outline"
          onClick={props.changeOwnerModaltoggle}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ChangeOwner;
